import React from 'react';

import { useProfileState, useProfileActions } from './ProfileContext';
import { updateCurrentUserName } from './restApi';

import Form from '../../Shared/UI/Form/components/Form';
import FormRow from '../../Shared/UI/FormRow/components/FormRow';
import Field from '../../Shared/UI/Field/components/Field';
import Input from '../../Shared/UI/Input/components/Input';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';

const UserNameUpdateForm = () => {
  const state = useProfileState();
  const { onResponse, onError, updateNewUserFirstName, updateNewUserLastName, closeUserNameUpdateModal } = useProfileActions();

  const handleSubmit = () => {
    updateCurrentUserName({
      onResponse,
      onError,
      body: {
        firstName: state?.userNameUpdateForm?.firstName || '',
        lastName: state?.userNameUpdateForm?.lastName || '',
        authenticityToken: document.querySelector("meta[name='csrf-token']")?.getAttribute("content")
      },
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <FormRow>
        <Field label="First Name" id="firstName">
          <Input
            type="text"
            value={state?.userNameUpdateForm?.firstName || ''}
            onChange={(e) => updateNewUserFirstName(e.target.value)}
          />
        </Field>

        <Field label="Last Name" id="lastName">
          <Input
            type="text"
            value={state?.userNameUpdateForm?.lastName || ''}
            onChange={(e) => updateNewUserLastName(e.target.value)}
          />
        </Field>
      </FormRow>

      <ResponsiveContainer name="form-actions">
        <FormActions>
          <Button
            variant="secondary"
            onClick={() => closeUserNameUpdateModal()}
          >
            Cancel
          </Button>
          <Button type="submit">
            Save Update
          </Button>
        </FormActions>
      </ResponsiveContainer>
    </Form>
  );
};

export default UserNameUpdateForm;
